import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'


require('./../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/FTP_Upload_auf_eine_Western_Digital_WD_MyCloud.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>In diesem Video erklären wir Ihnen wie Sie den FTP Upload bei einer WD MyCloud aktivieren und Ihre INSTAR Kamera so einrichten damit diese Videos und/oder Bilder auf die WD MyCloud aufnimmt. Auf <OutboundLink href="https://www.youtube.com/watch?v=jV3jpzXu51c" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)